import { render, staticRenderFns } from "./userMultiSelect.vue?vue&type=template&id=3bbc06c4"
import script from "./userMultiSelect.vue?vue&type=script&lang=js"
export * from "./userMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports